import React, { ChangeEvent } from "react";

interface InputTextProps {
  name: string;
  type?: string;
  label?: string;
  errors?: boolean;
  errormessage?: any;
  placeholder?: string;
  className?: string;
  required?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string | number | Date | null;
  isDisable?: boolean;
}

const InputText: React.FC<InputTextProps> = ({
  name,
  type = "text",
  label = "name",
  errors,
  errormessage,
  placeholder = "",
  className,
  required = false,
  onChange,
  value,
  isDisable,
}) => {
  const handleChange = (e: any) => {
    if (e.target.type === "number") {
      e.target.value = e.target.value.replace(/e/g, "");
      if (/^\d{0,9}$/.test(e.target.value)) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <div className="flex flex-col items-start gap-1.5 w-full my-1.5">
      <label className={`block text-sm font-normal capitalize text-slate-700 dark:text-slate-300 ${className || ""}`}>
        {label}
      </label>
      <input
        name={name}
        onChange={handleChange}
        value={value == null ? "" : value instanceof Date ? value.toISOString().substr(0, 10) : value}
        required={required}
        disabled={isDisable}
        className={`w-full h-10 px-3 rounded-md border bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-sm placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed ${
          errors
            ? "border-red-500 placeholder:text-red-400"
            : "border-slate-300 dark:border-slate-600"
        }`}
        type={type}
        placeholder={placeholder}
        autoComplete="off"
      />
      {errors && (
        <label className="text-red-500 text-[13px] font-normal">
          {errormessage ? errormessage : `${label} is mandatory`}
        </label>
      )}
    </div>
  );
};

export default React.memo(InputText);
